import baseRoute from '../baseRoute';

export default `${baseRoute}/crewType` as const;
